/**
 * Class describing the values and functions of a Route
 * Route objects are the result of a call to the Routing service, 
 *  providing distance and steps along a route between two Waypoints
 * 
 * @export {Route}
 * @class Route
 */

export default class Route {
    /**
     * Creates an instance of Route and determines the route steps and distance
     * @param {RouteNode} destinationNode 
     * @memberof Route
     */
    constructor (destinationNode) {
        this._route = [];
        // Keep track of the maps in a route
        let mapTrack = {};
        let currentNode = destinationNode;
        this._distance = currentNode.distanceToOrigin;
        while(currentNode.hasParent()) {
            this._route.push(currentNode);

            if (!mapTrack[currentNode.waypoint.map]) {
                mapTrack[currentNode.waypoint.map] = 1;
            } else {
                mapTrack[currentNode.waypoint.map]++;
            }

            currentNode = currentNode.parent;
        }
        this._route.push(currentNode);
        
        if (!mapTrack[currentNode.waypoint.map]) {
            mapTrack[currentNode.waypoint.map] = 1;
        } else {
            mapTrack[currentNode.waypoint.map]++;
        }

        // Only keep the map when there is more than one route waypoint on the map
        this._maps = Object.keys(mapTrack).filter(key => mapTrack[key] > 1);
        
        this._route.reverse();
        this._origin = this._route[0].waypoint.id;
        this._destination = this._route[ this._route.length - 1 ].waypoint.id;
    }

    get origin() {
        return this._origin;
    }

    get destination() {
        return this._destination;
    }

    get route() {
        return this._route;
    }

    get distance() {
        return this._distance;
    }

    get maps() {
        return this._maps;
    }
}


// WEBPACK FOOTER //
// ./src/classes/Route.js